//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  auth: false,
  layout: 'auth',
  data: () => ({
    formData: {},
    formName: 'password-reset',
  }),
  methods: {
    async submit() {
      try {
        const {data} = await this.$axios.post('password/email', this.formData);
        this.$toast.success(data.success);
      } catch (err) {
        this.$formulate.handle(err, this.formName);
      }
    },
  },
};
